/**
 * Collection of design tokens for screen breakpoints. These values determine layout adaptations
 * based on screen width.
 */ const breakpoints = {
    xs: 540,
    sm: 720,
    md: 960,
    lg: 1280,
    xl: 1920
};

export { breakpoints };
//# sourceMappingURL=breakpoints.js.map
